export default function ProfileHeader({ user }) {
  if (!user) {
    return (
      <div className="profile-header">
        <div className="profile-banner"></div>
        <div className="profile-loading">Loading profile...</div>
      </div>
    );
  }

  const {
    image,
    fullName,
    nickName,
    coin,
    referralCount,
    totalEarningAmount,
  } = user;

  /* ===== Currency Formatter ===== */
  const formatCurrency = (value) => {
    const number = Number(value) || 0;

    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  return (
    <div className="profile-header">
      {/* Banner */}
      <div className="profile-banner"></div>

      {/* Avatar */}
      <div className="profile-avatar-wrapper">
        <img
          src={image || "/default-user.png"}
          alt="profile"
          className="profile-avatar"
          onError={(e) => {
            e.target.src = "/default-user.png";
          }}
        />
      </div>

      {/* Basic Info */}
      <div className="profile-basic-info">
        <h2>{fullName || "Unnamed User"}</h2>
        <p>@{nickName || "username"}</p>

        {/* Stats */}
        <div className="profile-stats">
          <div className="stat-item">
            <h4>{Number(coin || 0).toLocaleString()}</h4>
            <span>Coins</span>
          </div>

          <div className="stat-item">
            <h4>{Number(referralCount || 0).toLocaleString()}</h4>
            <span>Referrals</span>
          </div>

          <div className="stat-item">
            <h4>{formatCurrency(totalEarningAmount)}</h4>
            <span>Earnings</span>
          </div>
        </div>
      </div>
    </div>
  );
}
